.bar {
  display: flex;
  flex: none;
  height: var(--mobile-tabbar-height);
  background: var(--bg-card);
  border-top: 1px solid var(--border);
  /* Полоса жестов на телефоне без кнопок проходит ровно под вкладками: без отступа
     нижний ряд пунктов оказывается под ней и не нажимается. */
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.tab {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  justify-content: center;
  min-width: var(--touch-min-target);
  padding: 0 var(--space-1);
  font-family: var(--font-ui);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: 0;
}

/*
 * Активная вкладка отличается ДВУМЯ способами: полоской сверху и яркостью подписи.
 * Одним цветом обойтись нельзя — на солнце телефон теряет контраст первым.
 */
.mark {
  width: 22px;
  height: 4px;
  background: transparent;
  border-radius: 2px;
}

.tabActive {
  color: var(--text-primary);
}

.tabActive .mark {
  background: var(--accent);
}

.label {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.moreWrap {
  position: relative;
  display: flex;
  flex: 1;
}

/* Лист «Ещё» разворачивается ВВЕРХ на всю ширину: он растёт от нижней полосы,
   а не висит углом над ней. */
.sheet {
  top: auto;
  right: 0;
  bottom: calc(100% + 1px);
  left: 0;
  width: auto;
  max-width: none;
  max-height: 60vh;
  overflow-y: auto;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.sheetList {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sheetItem {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  min-height: var(--touch-min-target);
  padding: 0 10px;
  font-size: var(--font-size-base);
  color: var(--text-primary);
  text-decoration: none;
  border-radius: var(--radius-md);
}

.sheetItemActive {
  background: var(--bg-sunken);
}

.sheetLabel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.sheetDot {
  flex: none;
  width: 6px;
  height: 6px;
  background: var(--danger);
  border-radius: 50%;
}

.sheetFooter {
  padding: var(--space-3) 10px 0;
  margin-top: var(--space-2);
  border-top: 1px solid var(--border);
}
